import { useMemo } from "react";
import { Entity } from "@common/types/entity";
import { useEntities } from "@hooks/useEntities";
import { UseEntitiesContextsOptions } from "@hooks/useEntitiesContexts";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { InjectedCommandOption } from "./lib";

interface UseEntityCommandOptionsParams {
    onEntitySelect: (entity: Entity) => void;
    disabled?: boolean;
    entitiesOptions?: UseEntitiesContextsOptions;
}

export function useEntityCommandOptions({
    onEntitySelect,
    disabled,
    entitiesOptions,
}: UseEntityCommandOptionsParams): InjectedCommandOption[] {
    const entities = useEntities(entitiesOptions);

    return useMemo(
        () =>
            entities.map((entity) => ({
                id: `entity-${entity.id}`,
                label: entity.name ?? "",
                icon: <EntityAvatar entity={entity} size="sm" aria-hidden />,
                keywords: [
                    entity.name ?? "",
                    entity.isPersonal ? "personal" : "business",
                ],
                disabled,
                onSelect: () => onEntitySelect(entity),
            })),
        [entities, onEntitySelect, disabled],
    );
}
